import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { eDotXetChungChiPhamViActionIds, IDotXetChungChiPhamViActionTypes } from "../../action-types/xet-chung-chi/IDotXetChungChiPhamViActions";
import { toLowerCaseDeep } from "../../../utils/toLowerCaseDeep";
import { rootActions } from "../../actions/rootActions";
import { put, takeEvery, takeLatest } from "redux-saga/effects";
import { dotXetChungChiPhamViApi } from "../../../api/xet-chung-chi/dotXetChungChiPhamViApi";
import { IDotXetChungChiPhamVi } from "../../../model/response/xet-chung-chi/IDotXetChungChiPhamVi";
const mainAction = rootActions.xetChungChi.dotXetChungChiPhamVi;

export function* dotXetChungChiPhamViSaga(): any {
    yield takeLatest(eDotXetChungChiPhamViActionIds.LOAD_BY_DOT_XET_START, loadByDotXetWoker);
    yield takeEvery(eDotXetChungChiPhamViActionIds.ADD_START, addWorker);
    yield takeEvery(eDotXetChungChiPhamViActionIds.DELETE_START, deleteWorker);
}

function* loadByDotXetWoker(action: IDotXetChungChiPhamViActionTypes): any {
    const id_dot_xet = action.payload as number;
    console.log("🚀 ~ function*loadByDotXetWoker ~ id_dot_xet:", id_dot_xet)
    const res: IBaseResponse = yield dotXetChungChiPhamViApi.SelectByDotXet(id_dot_xet);
    if (res.is_success) {
        yield put(mainAction.LOAD_BY_DOT_XET_SUCCESS(toLowerCaseDeep(res.data)));
    } else {
        yield put(mainAction.LOAD_BY_DOT_XET_ERROR(res.message ?? "Có lỗi khi tải đợt xét chứng chỉ tham số xét"));
    }
}

function* addWorker(action: IDotXetChungChiPhamViActionTypes): any {
    const payload = action.payload as IDotXetChungChiPhamVi;
    const res: IBaseResponse = yield dotXetChungChiPhamViApi.Insert(payload);
    if (res.is_success) {
        yield put(mainAction.ADD_SUCCESS(res.data));
    } else {
        yield put(mainAction.ADD_ERROR(res.message ?? "Có lỗi khi thêm đợt xét chứng chỉ phạm vi"));
    }
}

function* deleteWorker(action: IDotXetChungChiPhamViActionTypes): any {
    const id = action.payload as number;
    const res: IBaseResponse = yield dotXetChungChiPhamViApi.Delete(id);
    if (res.is_success) {
        yield put(mainAction.DELETE_SUCCESS(res.data));
    } else {
        yield put(mainAction.DELETE_ERROR(res.message ?? "Có lỗi khi xóa đợt xét chứng chỉ phạm vi"));
    }
}